export const localhost = 'localhost';
export const localhostapi = 'http://localhost:5551/api';
export const localhostreport = 'http://127.0.0.1:5000/master';
export const localImagePath = 'https://images.staticcontent.io/1xo';

export const qaServer = 'dev.1xlivepartners.com';
export const qaServerApi = 'https://api-dev.1xlivepartners.com';
export const qaCasinoAPI = 'https://api-dev.clubcasino.io';
export const qaSocketEndPoint = 'https://feed-dev.1xlivepartners.com';
export const qaReportsAPI = 'https://aff-report-dev.1xlivepartners.com';
export const qaSentryKeyDsn = "https://06d38331f86b402394bee13e71f081cd@o442524.ingest.sentry.io/5414529";
export const qaImagePath = 'https://images.staticcontent.io/1xo';
export const qaAffiliateUrl = 'https://dev.1xbook.live/affiliate';


export const livehost = 'team.1xbook.live';
export const livehostapi = 'https://team-api.1xbook.live';
export const liveCasinoAPI = 'https://api.clubcasinoz.com';
export const liveMasterAPI = 'https://api.bethubs.com';
export const liveSocketEndPoint = 'https://feed.team.1xbook.live';
export const liveReportsAPI = 'https://team-report.1xbook.live'
export const liveSentryKeyDsn = "https://187f2e0e3c5449cbb49360a57bd9df02@o442524.ingest.sentry.io/5414527";
export const liveImagePath = 'https://images.staticcontent.io/1xo';
export const liveAffiliateUrl = 'https://www.1xbook.live/affiliate';

export const OPERATOR_ID = "1XO"

export const tempProdHost = 'http://3.11.161.88/'

export const deckHerosApi = 'https://api.deckheroz.io';
export const deckHerosAdminUrl = 'https://admin.deckheroz.io';
export const liveImagePathNew = 'https://images.staticcontent.io';

export const realGamesApi = "https://cg.bethubs.com";